import SearchInput from 'components/SearchInput';
import React from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSearch } from 'hooks/useSearch';
import ShareFileUsersList, {
  SelectedUserIds,
  ToggleUserHandler,
} from 'features/content-library/components/share-users-selector/ShareFileUsersList';

export type ShareUsersSelectorProps = {
  toggleUser: ToggleUserHandler;
  selectedIds: SelectedUserIds;
  shareWithAll: boolean;
  onSelectAllChange: (checked: boolean) => void;
};

const ShareFileUsersSelector = React.memo(
  ({ toggleUser, selectedIds, shareWithAll, onSelectAllChange }: ShareUsersSelectorProps) => {
    const { t } = useTranslation(['content-library', 'modals', 'common']);

    const { onSearchInputChange, searchQuery } = useSearch();

    return (
      <div>
        <Box
          sx={{
            mb: 3,
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={shareWithAll}
                onChange={(e) => onSelectAllChange(e.target.checked)}
              />
            }
            label={t('modals:content_library.share_file.share_with_all_label')}
          />
        </Box>
        <Box
          sx={{
            mb: 6,
          }}
        >
          <SearchInput
            fullWidth
            placeholder={t('common:input_search_placeholder')}
            onChange={onSearchInputChange}
            inputProps={{
              'aria-label': t('common:input_search_placeholder'),
            }}
          />
        </Box>
        <ShareFileUsersList
          searchQuery={searchQuery}
          selectedIds={selectedIds}
          toggleUser={toggleUser}
          disabled={shareWithAll}
        />
      </div>
    );
  }
);

export default ShareFileUsersSelector;
